module.exports = __webpack_public_path__ + "static/media/conciliacao-integrada.c19019d4.jpg";